import Image from 'app/Components/Shared/Image/image';
import React, {useState, createRef} from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BottomLinks from '../BottomLinks';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {prepareNewWindowUrl} from '../../../../utilities/StringHelpers/StringHelpers.js';
import qrCodeImgContainer from '../EsimIcons/icon-192-frame.svg';
const QRCodePage = (props) => {
  const [imageUrl, setImageUrl] = useState(props.currentPhone?.qrCodeData?.base64Image);
  const ref = createRef(null);
  const signatureImageUrl = 'data:image/png;base64,';
  const codeScanInstructions = props.iContent.codeScanInstructions?.value;

  const onClickHandler = (props) => {
    props.setChangePage(true);
    googleAnalytics({category: 'sim_esim_process', eventType: 'להפעלה באמצעות קודי הפעלה', status: 'הפעלת eSIM'});
  };

  const googleAnalytics = (params) => {
    gaEvent(params.category, params.eventType, params.status);
  };

  return (
    <div className='barcode-main-container'>
      <div className='screenshot-style' ref={ref}>
        <p className='main-title-barcode-text'>להפעלת הקו</p>
        <p className='phone-number-barcode-text'>{props.currentPhone?.phoneNumber}</p>
        <p className='barcode-sub-title'>סרקו את הברקוד באמצעות הנייד שבו תרצו להפעיל את ה-eSIM</p>
        <div className='barcode-img'>
          <Image src={require('../EsimIcons/qr-code-scan.svg')} />
        </div>
        <div className='qr-code-img-container' style={{ backgroundImage: qrCodeImgContainer.bg() }}>
          <Image className='qr-code-img' src={signatureImageUrl + imageUrl} />
        </div>
      </div>
      {codeScanInstructions && (
        <>
          <p className='important-info-text'>מפעילים את ה-eSIM במכשיר הזה?</p>
          <div className='buttons-container'>
            <BtnSubmit
              isDisplayArrows={false}
              text='להוראות סריקת ה-QR מהנייד'
              onclick={() => {
                prepareNewWindowUrl(codeScanInstructions, props.context);
              }}
            />
          </div>
        </>
      )}
      <hr />
      <div className='link-container'>
        <p className='important-info-text'>אין באפשרותכם לסרוק?</p>
        <a onClick={() => onClickHandler(props)}>הפעילו את ה-eSIM עם קודי הפעלה</a>
      </div>
      <BottomLinks context={props.context} iContent={props.iContent} setPopUp={(isShowPopUp) => props.setPopUp(isShowPopUp)} />
    </div>
  );
};

export default QRCodePage;
